var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_11462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4618 13.0333C18.274 11.5323 15.4755 12.1429 14 14.3816C12.7789 16.2642 10.9217 16.4932 10.184 16.4932C7.84344 16.4932 6.24071 14.8395 5.75734 13.135C5.75734 13.1096 5.75734 13.1096 5.7319 13.0841C5.7319 13.0587 5.7319 13.0587 5.70646 13.0333C5.52838 12.3209 5.4775 11.9902 5.4775 11.227C5.4775 7.15656 9.64971 2.60274 15.6791 2.60274C21.8611 2.60274 25.3718 7.3092 26.2877 9.90411C26.2622 9.85323 26.2622 9.80235 26.2368 9.77691C24.5323 4.66341 19.6986 1 14 1C6.82583 1 1 6.82583 1 14C1 20.411 5.63014 25.9061 12.0411 25.9061C17.1546 25.9061 20.6145 23.0313 22.1918 19.0881C23.0568 16.9256 22.4462 14.3816 20.4618 13.0333Z",
    fill: "#003763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2864 10.0558C25.5232 7.51174 21.9615 2.5 15.6015 2.5C9.57211 2.5 5.3999 7.05382 5.3999 11.1243C5.3999 11.8875 5.45078 12.2182 5.62887 12.9305C5.55254 12.6252 5.50166 12.2945 5.50166 12.0147C5.50166 7.76614 9.7502 4.81507 14.1259 4.81507C20.0535 4.81507 24.8363 9.62329 24.8363 15.5254C24.8363 20.1556 22.1651 24.1751 18.2981 26.1086C23.3099 24.3023 26.8715 19.4941 26.8715 13.8718C26.8715 12.5489 26.6934 11.3532 26.2864 10.0558Z",
    fill: "#E4022D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_11462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 25.2114,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.d2c413a82c28def1ab6671ab9fffd446.svg";
export { ForwardRef as ReactComponent };